import { PlanItem } from './PlanItem';
import type { ComparisonTablePlan } from '../types';

interface Props {
  plans: ComparisonTablePlan[];
}

export const Plans = ({ plans }: Props) => {
  return (
    <div className="plans-container-wrapper">
      <div className="plans-container">
        {plans.map((plan) => (
          <PlanItem key={plan.name} plan={plan} />
        ))}
      </div>
    </div>
  );
};
